import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { MaritalActions } from './marital.actions';

@Injectable({
  providedIn: 'root'
})
export class MaritalEffects {
  sendMaritalEffect$: Observable<Action>;

  constructor(private actions$: Actions) {
    this.sendMaritalEffect$ = createEffect(
      (): any =>
        this.actions$.pipe(
          ofType(MaritalActions.submitSuccess),
          tap(() => {})
        ),
      { dispatch: false }
    );
  }
}
